module.exports = __webpack_public_path__ + "img/table-empty@2x.098dd32e.png";